var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullViewportBackgroundElement',{staticClass:"background-vimeo-video-displayer"},[_c('iframe',{key:_vm.iframeKey,attrs:{"src":_vm.vimeoIframeSource,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }